import React from 'react';
import { Box, LinearProgress } from '@mui/material';

const LoadingScreen = () => (
  <Box width={400}>
    <LinearProgress />
  </Box>
);

export default LoadingScreen;
